// import AnalyticsSaveGameModel from "./AnalyticsSaveGameModel";

export default class SaveGameModel {

    constructor() {
        this.reset();
    }

    reset() {
        this._version = SaveGameModel.CURRENT_SAVE_GAME_VERSION;

        this._internalStakeholders = {};
        this._hubSaveGame = {};
        this._keyDecisions = {};
        this._teaCorner = {};
        this._progress = {};
        this._files = {};
        this._chats = {};
        this._emails = {};
        this._feedback = {};
        this._npcs = {};
        this._variables = {};
        this._story = {};
        this._gameFinished = false;
        this._seenOnboarding = false;
        this._gameStart = new Date();

        // this._analyticsSaveGameModel = new AnalyticsSaveGameModel();
    }

    get version() {
        return this._version;
    }

    get internalStakeholders() {
        return this._internalStakeholders;
    }

    set internalStakeholders(value) {
        this._internalStakeholders = value;
    }

    get hubSaveGame() {
        return this._hubSaveGame;
    }

    set hubSaveGame(value) {
        this._hubSaveGame = value;
    }

    get keyDecisions() {
        return this._keyDecisions;
    }

    set keyDecisions(value) {
        this._keyDecisions = value;
    }

    get teaCorner() {
        return this._teaCorner;
    }

    set teaCorner(value) {
        this._teaCorner = value;
    }

    get progress() {
        return this._progress;
    }

    set progress(value) {
        this._progress = value;
    }

    get files() {
        return this._files;
    }

    set files(value) {
        this._files = value;
    }

    get chats() {
        return this._chats;
    }

    set chats(value) {
        this._chats = value;
    }

    get emails() {
        return this._emails;
    }

    set emails(value) {
        this._emails = value;
    }

    get feedback() {
        return this._feedback;
    }

    set feedback(value) {
        this._feedback = value;
    }

    get npcs() {
        return this._npcs;
    }

    set npcs(value) {
        this._npcs = value;
    }

    get variables() {
        return this._variables;
    }

    set variables(value) {
        this._variables = value;
    }

    get story() {
        return this._story;
    }

    set story(value) {
        this._story = value;
    }

    get gameFinished() {
        return this._gameFinished;
    }

    set gameFinished(value) {
        this._gameFinished = value;
    }

    get seenOnboarding() {
        return this._seenOnboarding;
    }

    set seenOnboarding(value) {
        this._seenOnboarding = value;
    }

    get gameStart() {
        return this._gameStart;
    }

    set gameStart(value) {
        return this._gameStart = value;
    }

    // get analyticsSaveGameModel() {
    //     return this._analyticsSaveGameModel;
    // }

    toObject() {
        return {
            version: this.version,
            internalStakeholders: this.internalStakeholders,
            hubSaveGame: this.hubSaveGame,
            keyDecisions: this.keyDecisions,
            teaCorner: this.teaCorner,
            progress: this.progress,
            files: this.files,
            chats: this.chats,
            emails: this.emails,
            feedback: this.feedback,
            npcs: this.npcs,
            variables: this.variables,
            story: this.story,
            gameFinished: this.gameFinished,
            seenOnboarding: this.seenOnboarding,
            gameStart: this.gameStart,
            // analytics: this._analyticsSaveGameModel.toObject(),
        };
    }

    fromObject(obj) {
        this._version = obj.version;
        this.internalStakeholders = obj.internalStakeholders;
        this.hubSaveGame = obj.hubSaveGame;
        this.keyDecisions = obj.keyDecisions;
        this.teaCorner = obj.teaCorner;
        this.progress = obj.progress;
        this.files = obj.files;
        this.chats = obj.chats;
        this.emails = obj.emails;
        this.feedback = obj.feedback;
        this.npcs = obj.npcs;
        this.variables = obj.variables;
        this.story = obj.story;
        this.gameFinished = obj.gameFinished;
        this.seenOnboarding = obj.seenOnboarding;
        this.gameStart = obj.gameStart;
        // this._analyticsSaveGameModel.fromObject(obj.analytics);
    }

    serialize() {
        return new Promise((resolve, reject) => {
            try {
                resolve(JSON.stringify(this.toObject()));
            } catch (ex) {
                console.warn(`[SaveGameModel] Unable to serialize save game to JSON.`, ex);

                reject(ex);
            }
        });
    }

    deserialize(data) {
        return new Promise((resolve, reject) => {
            try {
                const obj = JSON.parse(data);
                this.fromObject(obj);

                resolve();
            } catch (ex) {
                console.warn(`[SaveGameModel] Unable to parse save game JSON.`, ex);

                reject(ex);
            }
        });
    }
}

SaveGameModel.CURRENT_SAVE_GAME_VERSION = 2; // Bumping this version number will older save games of players. They will get a popup saying their savegame is no longer supported.